export default __webpack_public_path__ + "static/media/Lancer.69e8175c.svg";